import React from 'react';

import { Redirect, Switch } from 'react-router-dom';

import Route from './route';
import {
  NotFound,
  Home as PharmacistHome,
  Login,
  Profile,
  ValidateHome,
} from '~/modules/pharmacist/pages';
import { Home as PatientHome } from '~/modules/patient/pages';
import ForgetPassword from '~/modules/pharmacist/pages/login/component/forgetPassword';
import ResetPassword from '~/modules/pharmacist/pages/login/component/resetPassword';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/receita" />
      </Route>
      <Route path="/receita/login/" exact component={() => <Login />} />
      <Route
        path="/receita/forgetPassword"
        component={() => <ForgetPassword />}
      />
      <Route
        path="/receita/resetPassword"
        component={() => <ResetPassword />}
      />
      <Route path="/receita/perfil" component={() => <Profile />} />
      <Route path="/p/:id" exact component={() => <PatientHome />} />
      <Route path="/receita" exact component={() => <PharmacistHome />} />
      <Route path="/receita/:id" exact component={() => <PharmacistHome />} />

      <Route path="/valida" exact component={() => <ValidateHome />} />
      <Route path="/valida/:id" exact component={() => <ValidateHome />} />

      <Route path="/404" exact component={() => <NotFound />} />

      <Route path="*" component={() => <NotFound />} />
    </Switch>
  );
}
